module.exports = __webpack_public_path__ + "static/media/empty_notices.b09001d0.png";